import { render, staticRenderFns } from "./ListTypes.vue?vue&type=template&id=63e4e180&"
import script from "./ListTypes.vue?vue&type=script&lang=js&"
export * from "./ListTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports